import { Typography } from '@mui/material';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { LwBlockGridContainer } from 'redesign';
import { ServiceAgreementBlock } from '../service-agreement-block';

export const ServiceAgreementList = ({ data }: { data: ServiceAgreementsResponse }) => {
  const { t } = useTranslation('ogp-screen-specific');

  if (data.length === 0) {
    return <Typography>{t('collegial-lending-page.no-service-agreements')}</Typography>;
  }

  return (
    <LwBlockGridContainer container spacing={4}>
      {data.map((item) => (
        <ServiceAgreementBlock key={item.id} serviceAgreement={item} />
      ))}
    </LwBlockGridContainer>
  );
};
